/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface InfluencerDetail {
  acceptGlamstar?: Date;
  amount?: number;
  boost?: number;
  couponName?: string;
  dateCreated?: Date;
  description?: string;
  enabled?: number;
  firstName?: string;
  influencerStatus?: string;
  influencerStatusId?: number;
  influencerStatusTypeId?: number;
  lastName?: string;
  name?: string;
  personId?: number;
  pis?: string;
  rg?: string;
}
